import { signal } from "@preact/signals-react";

export const showFileUpload = signal(false);
export const showInvalidFormatDialog = signal(false);
